import { defineMessages } from "react-intl";

const messages = defineMessages({
  cardTitle: {
    id: "dashboard.cards.closedStageDealCount.title",
    defaultMessage:
      "{stageTypes, select, true {{entityList} Count} other {Closed Stage Count}} <date>{dateRange, select, day {{dateSubRange, select, this {today} last {yesterday} other {}}} week {{dateSubRange, select, this {this week} last {last week} other {}}} month {{dateSubRange, select, this {this month} last {last month} other {}}} quarter {{dateSubRange, select, this {this quarter} last {last quarter} other {}}} year {{dateSubRange, select, this {this year} last {last year} other {}}} other{}}</date>",
    description: "Title of the Deals Count card",
  },
  modalTitle: {
    id: "dashboard.editModal.closedStageDealCount.title",
    defaultMessage: "Edit “Closed Stage Deal Count”",
    description: "Title of the Edit Deals Count modal",
  },
  orgGoal: {
    id: "dashboard.editModal.closedStageDealCount.goal.org",
    defaultMessage:
      "Deals that are <b>owned by any user</b>, and meet the above criteria will {maxAmount, select, true {{maxAmount, select, true {count toward the max amount} other {contribute to this goal}}} other {contribute to this goal}}.",
    description: "Goal description for org level of the Edit Records Out of Frequency modal",
  },
  teamGoal: {
    id: "dashboard.editModal.closedStageDealCount.goal.team",
    defaultMessage:
      "Deals that are <b>owned by any user in this team</b>, and meet the above criteria will {maxAmount, select, true {count toward the max amount} other {contribute to this goal}}.",
    description: "Goal description for team level of the Edit Records Out of Frequency modal",
  },
  user: {
    id: "dashboard.editModal.closedStageDealCount.goal.user.placeholder",
    defaultMessage: "user",
    description: "Placeholder used for Goal description for user level when user is not found",
  },
  userGoal: {
    id: "dashboard.editModal.closedStageDealCount.goal.user",
    defaultMessage:
      "Deals that are <b>owned by {user}</b>, and meet the above criteria will {maxAmount, select, true {count toward the max amount} other {contribute to this goal}}.",
    description: "Goal description for user level of the Edit Records Out of Frequency modal",
  },
});

export default messages;
